import {LicenseEquipmentFuelTypeCd} from '../';
import {EnumHelper} from './enum-helper';

export class LicenseEquipmentFuelTypeCdHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in LicenseEquipmentFuelTypeCd ) {
      this._values.push(LicenseEquipmentFuelTypeCd[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): LicenseEquipmentFuelTypeCd {

    for ( const obj in LicenseEquipmentFuelTypeCd ) {
      if (LicenseEquipmentFuelTypeCd[obj] === value){
        return LicenseEquipmentFuelTypeCd[obj] as LicenseEquipmentFuelTypeCd;
      }
    }
  }
}

const LicenseEquipmentFuelTypeCdHelper = new LicenseEquipmentFuelTypeCdHelperEnumHelperClass();
export default LicenseEquipmentFuelTypeCdHelper;
